import React, { useEffect, useState } from "react";
import "../../../../Login.css";
import bg1 from "../../../media/bg-01.jpg";
import BaseUrl from "../../../utils/BaseUrl";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const url = BaseUrl();

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [isAuthToken] = useState(localStorage.getItem("_token_"));

  useEffect(() => {
    if (isAuthToken !== null) {
      navigate("/");
    }
  }, [isAuthToken]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Email ou mot de passe vide !");
      return;
    }

    setLoading(true);
    const _formData = new FormData();
    _formData.append("email", username);
    _formData.append("password", password);
    try {
      const resp = await axios.post(url.base + "/login", _formData, {
        headers: { "Content-Type": "application/json" },
      });
      setLoading(false);
      if (resp.status === 200) {
        localStorage.setItem("_token_", resp.data.access_token);
        navigate("/approvisionnements");
        window.location.reload();
      }
    } catch (error) {
      setLoading(false);
      if (error?.response?.status === 401) {
        setError(error?.response.data.error);
      } else {
        setError("Un problème est survenu !");
      }
    }
  };

  return (
    <div className="auth-page" style={{ backgroundImage: `url(${bg1})` }}>
      {/* Brand panel — hidden on small screens, becomes the full-bleed
          background behind the form card instead (see Login.css) */}
      <div className="auth-brand-panel">
        <div className="auth-brand-overlay"></div>
        <div className="auth-brand-content">
          <img src="/assets/logo.png" alt="Distriforce" className="auth-logo" />
          <h1>Distriforce Reporting</h1>
          <p>La plateforme de pilotage EVD &amp; Momo pour vos équipes commerciales.</p>
          <ul className="auth-feature-list">
            <li><i className="mdi mdi-chart-areaspline"></i> Suivi des ventes EVD et Momo en temps réel</li>
            <li><i className="mdi mdi-truck-delivery"></i> Approvisionnements des commerciaux</li>
            <li><i className="mdi mdi-swap-horizontal-bold"></i> Transactions ADV centralisées</li>
          </ul>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-card">
          <img src="/assets/logo.png" alt="Distriforce" className="auth-logo auth-logo-mobile" />
          <h2 className="auth-title">Connexion</h2>
          <p className="auth-subtitle">Entrez vos identifiants pour accéder à votre espace.</p>

          {error && (
            <div className="auth-alert">
              <i className="mdi mdi-alert-circle-outline"></i> {error}
            </div>
          )}

          <form onSubmit={handleLogin} noValidate>
            <div className="auth-field">
              <label className="auth-label">Adresse e-mail</label>
              <div className="auth-input-group">
                <i className="mdi mdi-email-outline"></i>
                <input
                  type="email"
                  name="username"
                  placeholder="vous@distriforce.com"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>

            <div className="auth-field">
              <label className="auth-label">Mot de passe</label>
              <div className="auth-input-group">
                <i className="mdi mdi-lock-outline"></i>
                <input
                  type={showPassword ? "text" : "password"}
                  name="pass"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="auth-toggle-password"
                  onClick={() => setShowPassword((s) => !s)}
                  tabIndex={-1}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <i className={`mdi ${showPassword ? "mdi-eye-off-outline" : "mdi-eye-outline"}`}></i>
                </button>
              </div>
            </div>

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Connexion en cours...</span>
                </span>
              ) : (
                <>
                  Connexion <i className="mdi mdi-arrow-right"></i>
                </>
              )}
            </button>
          </form>

          <p className="auth-footer">© {new Date().getFullYear()} Distriforce — Tous droits réservés</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
